<template>
  <div class="carriers">
    <div class="carrier-chip" v-for="carrier in carriers" :key="carrier">
      {{ carrier }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CarrierChips",
  props: {
    carriers: {
      type: Array,
      required: true,
    },
  },
};
</script>
